<div class="min-hight">
    <app-header></app-header>
    <router-outlet></router-outlet>
    <ngx-spinner></ngx-spinner>
    <app-audio-player></app-audio-player>
    <app-video-miniplayer *ngIf="showPlayer"></app-video-miniplayer>
</div> 

<app-footer></app-footer>